"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.gatsbyImageUrl = gatsbyImageUrl;
exports.resolveGatsbyImage = resolveGatsbyImage;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gatsbyPluginImage = require("gatsby-plugin-image");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// gatsby-plugin-image renders the real photo at opacity 0 until hydration.
// A plain picture paints as soon as the file arrives.
function resolveGatsbyImage(image) {
  var _image$childImageShar;
  if (!image) return null;
  if (image.images && (image.layout || image.width)) return image;
  return (0, _gatsbyPluginImage.getImage)(image) || ((_image$childImageShar = image.childImageSharp) === null || _image$childImageShar === void 0 ? void 0 : _image$childImageShar.tile) || image.tile || null;
}
function gatsbyImageUrl(image) {
  var _data$images$fallback, _data$images$fallback2;
  var data = resolveGatsbyImage(image);
  if (!(data !== null && data !== void 0 && data.images)) return null;
  var webp = (data.images.sources || []).find(function (source) {
    return source.type === "image/webp";
  });
  var srcSet = (webp === null || webp === void 0 ? void 0 : webp.srcSet) || ((_data$images$fallback = data.images.fallback) === null || _data$images$fallback === void 0 ? void 0 : _data$images$fallback.srcSet);
  if (srcSet) {
    var candidates = srcSet.split(",").map(function (part) {
      return part.trim();
    }).filter(Boolean);
    var last = candidates[candidates.length - 1];
    return last ? last.split(/\s+/)[0] : null;
  }
  return ((_data$images$fallback2 = data.images.fallback) === null || _data$images$fallback2 === void 0 ? void 0 : _data$images$fallback2.src) || null;
}
function EagerGatsbyImage(_ref) {
  var image = _ref.image,
    alt = _ref.alt,
    className = _ref.className,
    style = _ref.style,
    sizes = _ref.sizes,
    fetchPriority = _ref.fetchPriority,
    main = _ref.main;
  var data = resolveGatsbyImage(image);
  if (!(data !== null && data !== void 0 && data.images)) {
    return /*#__PURE__*/_react["default"].createElement("picture", {
      className: className,
      style: style
    });
  }
  var sources = data.images.sources || [];
  var fallback = data.images.fallback;
  return /*#__PURE__*/_react["default"].createElement("picture", {
    className: className,
    style: _objectSpread({
      display: "block",
      width: "100%",
      height: "100%"
    }, style)
  }, sources.map(function (source) {
    return /*#__PURE__*/_react["default"].createElement("source", {
      key: source.type || source.srcSet,
      type: source.type,
      srcSet: source.srcSet,
      sizes: sizes || source.sizes
    });
  }), /*#__PURE__*/_react["default"].createElement("img", {
    alt: alt || "",
    src: fallback === null || fallback === void 0 ? void 0 : fallback.src,
    srcSet: fallback === null || fallback === void 0 ? void 0 : fallback.srcSet,
    sizes: sizes || (fallback === null || fallback === void 0 ? void 0 : fallback.sizes),
    width: data.width,
    height: data.height,
    loading: "eager",
    fetchPriority: fetchPriority,
    decoding: "async",
    "data-main-image": main ? "" : undefined,
    style: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
      display: "block"
    }
  }));
}
EagerGatsbyImage.propTypes = {
  image: _propTypes["default"].object,
  alt: _propTypes["default"].string,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  sizes: _propTypes["default"].string,
  fetchPriority: _propTypes["default"].string,
  main: _propTypes["default"].bool
};
var _default = exports["default"] = EagerGatsbyImage;